import moment from 'moment';
import Compressor from 'compressorjs';
import { Message, Loading } from 'element-ui';
import { getToken } from '@/utils/auth';
import md5 from 'js-md5';

export default {
  /**
   * Check if an element has a class
   * @param {HTMLElement} ele
   * @param {string} cls
   * @returns {boolean}
   */
  hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  },

  /**
   * Add class to element
   * @param {HTMLElement} ele
   * @param {string} cls
   */
  addClass(ele, cls) {
    if (!this.hasClass(ele, cls)) ele.className += ' ' + cls;
  },

  /**
   * Remove class from element
   * @param {HTMLElement} ele
   * @param {string} cls
   */
  removeClass(ele, cls) {
    if (this.hasClass(ele, cls)) {
      const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      ele.className = ele.className.replace(reg, ' ');
    }
  },

  /**
   * @param {HTMLElement} element
   * @param {string} className
   */
  toggleClass(element, className) {
    if (!element || !className) {
      return;
    }
    let classString = element.className;
    const nameIndex = classString.indexOf(className);
    if (nameIndex === -1) {
      classString += '' + className;
    } else {
      classString =
        classString.substr(0, nameIndex) +
        classString.substr(nameIndex + className.length);
    }
    element.className = classString;
  },

  // moment插件
  moment,

  // 设置表单筛选组件和请求参数值
  setFormValue(that, queryList, listQuery, key, value, disabled) {
    that.$set(listQuery, key, value);
    queryList.forEach(item => {
      if (item.key === key) {
        that.$set(item, 'value', value);
        that.$set(item, 'disabled', disabled);
      }
    });
  },
  // 每三位加,
  toThousands (num = 0)  {
    return num.toString().replace(/\d+/, function(n) {
      return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    });
  },
  // 下载文件
  saveExportFile(url, filename, fileType = 'xls') {
    const loading = Loading.service({
      text: '导出中...',
      background: 'rgba(255, 255, 255, 0.5)',
    });
    const xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.responseType = 'blob';

    const token = getToken();
    if (token) {
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    }
    const timestamp = new Date().getTime();
    const sign = md5(timestamp + 'coursezjer_admin');
    xhr.setRequestHeader('Timestamp', timestamp);
    xhr.setRequestHeader('Sign', sign);
    xhr.setRequestHeader('domain', window.location.host);

    xhr.onload = () => {
      if (xhr.status === 200) {
        const type = { xls: 'application/vnd.ms-excel', zip: 'application/zip', formatsXls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }[fileType];
        // console.log(xhr);
        if (xhr.response.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(xhr.response, 'utf-8');
          reader.onload = () => {
            const readerRes = JSON.parse(reader.result);
            Message.error(readerRes.msg || '未找到下载文件');
          };
        } else { // blob: text/xml
          const blob = new Blob([xhr.response], { type });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename + '.' + fileType);
          } else {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            link.download = filename || '导出文件';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } else {
        Message.error('未找到下载文件');
      }
      loading.close();
    };
    xhr.onerror = () => {
      Message.error('未找到下载文件');
      loading.close();
    };
    xhr.send();
  },
  // 导入 传文件返回文件并保存
  importFile(url, file, filename, callBack, fileType = 'xls', param) {
    // const loading = Loading.service({
    //   text: '导入中...',
    //   background: 'rgba(255, 255, 255, 0.5)',
    // });
    const xhr = new XMLHttpRequest();
    xhr.open('post', url, true);
    const data = new FormData();
    data.append('file', file);
    if (param) {
      for( let i in param) {
        data.append(i, param[i]);
      }
    }
    xhr.responseType = 'blob';

    const token = getToken();
    if (token) {
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    }
    const timestamp = new Date().getTime();
    const sign = md5(timestamp + 'coursezjer_admin');
    xhr.setRequestHeader('Timestamp', timestamp);
    xhr.setRequestHeader('Sign', sign);
    xhr.setRequestHeader('domain', window.location.host);

    xhr.onload = () => {
      if (xhr.status === 200) {
        const type = { xls: 'application/vnd.ms-excel', zip: 'application/zip', formatsXls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }[fileType];
        // console.log(xhr);
        if (xhr.response.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(xhr.response, 'utf-8');
          reader.onload = () => {
            const res = JSON.parse(reader.result);
            if (res.code === '0') {
              callBack('all');
            } else {
              Message.error(res.msg || '未找到下载文件');
              callBack();
            }
          };
        } else { // blob: text/xml
          const blob = new Blob([xhr.response], { type });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            link.download = filename || ('导出文件' + '.' + fileType);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          callBack('some');
        }
      } else {
        Message.error('未找到下载文件');
        callBack();
      }
    };
    xhr.onerror = () => {
      Message.error('未找到下载文件');
      callBack();
    };
    xhr.send(data);
  },
  // 下载二进制文件
  exportArraybufferExcel(data, fileName) {
    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  downloadFile(url, name) {
    let arr = url.split('.');
    this.getBlob(url).then(blob => {
      this.saveAs(blob, `${name}.${arr[arr.length - 1]}`);
    });
  },
  getBlob(url) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      };
  
      xhr.send();
    });
  },
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
  
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      
      link.click();
      body.removeChild(link);
  
      window.URL.revokeObjectURL(link.href);
    }
  },
  compressImg(propFile, quality = 0.9, maxWidth = 2000) {
    return new Promise((resolve, reject) => {
      new Compressor(propFile, {
        success(result) {
          resolve(result);
        },
        quality,
        maxWidth,
        error(err) {
          reject(err);
        },
      });
    });
  },
  // 格式化富文本内容
  formatRichText(html, maxWidth) {
    let newContent = html.replace(/<img[^>]*>/gi, (match, capture) => {
      match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
      match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
      match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
      return match;
    });
    newContent = newContent.replace(/style="[^"]+"/gi, (match, capture) => {
      match = match.replace(/width:[^;]+;/gi, `max-width:${maxWidth};`).replace(/width:[^;]+;/gi, `max-width:${maxWidth};`);
      return match;
    });
    newContent = newContent.replace(/<br[^>]*\/>/gi, '');
    newContent = newContent.replace(/[\n]/g, '<br>');
    // newContent = newContent.replace(/ /g, '&nbsp;');
    newContent = newContent.replace(/\<img/gi, '<img style="max-width:' + maxWidth + '"');
    return newContent;
  },
  // 格式化标签名
  tagNamesFilter(tagNames) {
    if (typeof tagNames === 'undefined' || tagNames === null || tagNames === '') return '';

    let tagList = tagNames.replace(/，/g, ',').split(','); // 替换 '，' 为 ','
    if(tagList.length > 0) {
      tagList = [...new Set(tagList.map(item => item.replace(/(^\s*)|(\s*$)/g,"")))] // 去除每个元素首位空格 然后去重
      return tagList.join(',');
    } else {
      return ''
    }
  },
  getElementTop(elem) {
    if (elem) {
      let elemTop = elem.offsetTop;// 获得elem元素距相对定位的父元素的top
      elem = elem.offsetParent;// 将elem换成起相对定位的父元素
      while (elem != null) { // 只要还有相对定位的父元素
        // 获得父元素 距他父元素的top值,累加到结果中
        elemTop += elem.offsetTop;
        // 再次将elem换成他相对定位的父元素上;
        elem = elem.offsetParent;
      }
      return elemTop;
    }
  },
  estimateRegistrationTime(beginDate, endDate) {
    if (beginDate && endDate) {
      var begin = new Date(beginDate).getTime();
      var end = new Date(endDate).getTime();
      var day = (end - begin) / (24 * 60 * 60 * 1000);
      if (day > 366) {
        return false;
      }else{
        return true;
      }
    } else {
      return false
    }
  },
};
